// extracted by mini-css-extract-plugin
export default {"widget":"DetailBoxesDatesWidget_widget__J5YD6","link":"DetailBoxesDatesWidget_link__9I1V3","title":"DetailBoxesDatesWidget_title__vOnpp","name":"DetailBoxesDatesWidget_name__Y51Qf"};